import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import ValidationMixin from '@/mixins/ValidationMixin';

/**
 * ValidationText
 */
@Component
export default class ValidationText extends mixins(ValidationMixin) {
    /**
     * Name of the field
     */
    @Prop({ type: String, required: false }) readonly name!: string;

    /**
     * Errors for the field
     */
    @Prop({ type: Array, required: true }) readonly errors!: any[];

    /**
     * Code of the error (error name)
     */
    @Prop({ type: String, required: false }) readonly code!: string;

    /**
     * Namespace (if needed)
     */
    @Prop({ type: String, default: 'default' }) readonly ns!: string;
}
